// src/components/HeaderSearch.js
import * as React from 'react';
import { useLocation } from 'react-router-dom';
import {
    Box,
    TextField,
    InputAdornment,
    IconButton,
} from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import CloseIcon from '@mui/icons-material/Close';
import {
    getSearchableResourceFromPath,
    getResourceSearchConfig,
} from '../config/resourceSearch';
import { useResourceSearchState } from '../hooks/useResourceSearch';

const ActiveHeaderSearch = ({ resource }) => {
    const config = getResourceSearchConfig(resource);
    const { value, setValue, clear } = useResourceSearchState(resource);

    if (!config) {
        return null;
    }

    const handleChange = (event) => {
        setValue(event.target.value);
    };

    const handleClear = () => {
        clear();
    };

    return (
        <Box
            sx={{
                width: { xs: '100%', sm: 320 },
                ml: { xs: 0, sm: 2 },
            }}
        >
            <TextField
                size="small"
                fullWidth
                variant="outlined"
                placeholder={config.placeholder}
                value={value}
                onChange={handleChange}
                InputProps={{
                    startAdornment: (
                        <InputAdornment position="start">
                            <SearchIcon fontSize="small" />
                        </InputAdornment>
                    ),
                    endAdornment: value ? (
                        <InputAdornment position="end">
                            <IconButton onClick={handleClear} size="small">
                                <CloseIcon fontSize="small" />
                            </IconButton>
                        </InputAdornment>
                    ) : null,
                }}
            />
        </Box>
    );
};

export default function HeaderSearch() {
    const location = useLocation();
    const resource = React.useMemo(
        () => getSearchableResourceFromPath(location.pathname),
        [location.pathname]
    );

    if (!resource) {
        return null;
    }

    return <ActiveHeaderSearch resource={resource} />;
}
